<template>
  <button class="like-btn" v-bind:class="likeClass" @click="addLike" title="좋아요 버튼" v-bind:disabled="isDisable">
    <i class="fa fa-heart liked-heart"></i>
    <i class="fa fa-heart-o"></i>
    <span class="alt-text">{{altText}}</span>
    <span class="like-text">{{count}}</span>
  </button>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'like-btn',
    props: ['likeCount', 'postId', 'isMemberPost'],
    data() {
      return {
        count: null,
        likeClass: '',
        altText: '좋아요 버튼 하트 미표시된 상태',
        isDisable: false,
      };
    },
    computed: {
      url() {
        return (this.isMemberPost) ? `/api/member-posts/${this.postId}/like` : `/api/posts/${this.postId}/like`;
      },
    },
    methods: {
      addLike() {
        axios.post(this.url).then((count) => {
          this.count = count.data;
          this.likeClass = 'liked';
          this.altText = '좋아요 버튼 하트 표시된 상태';
          this.isDisable = 'disabled';
        }).catch((error) => {
          alert(error.data.msg);
        });
      },
    },
    created() {
      this.count = this.likeCount;
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// LikeBtn.vue?607d51cf